import React from 'react';
import styled, { css } from 'styled-components';
import { Button as RebassButton, Box, Flex } from 'rebass';
import { darken } from 'polished';
import { themeGet } from 'styled-system';

import Icon from '../Icon';
import Text from '../Text';
import { COLOR } from '../../Theme';

const RBButton = styled(({ variant, ...restProps }) => <RebassButton {...restProps} />)`
  cursor: pointer;
  ${props => css`
    &:hover {
      background: ${darken(0.05, themeGet('colors.' + props.bg, COLOR.primary)(props))};
    }
  `};
  &:focus {
    box-shadow: none;
  }
  ${props =>
    props.variant === 'action' &&
    css`
      border: 2px solid ${COLOR.darkBlue};
      background: ${COLOR.white};
      color: ${COLOR.primary};

      &:hover {
        background: ${COLOR.greyscale.grey5};
      }
    `};
`;

const RButton = ({
  variant,
  color = 'white',
  bg = 'primary',
  icon,
  iconType = 'material',
  iconRight,
  iconStyle,
  title,
  titleColor = 'inherit',
  ...restProps
}) => {
  const _titleColor = variant === 'action' ? COLOR.darkBlue : titleColor;
  const iconProps = {
    name: icon,
    type: iconType,
    iconStyle,
  };
  return (
    <RBButton color={color} bg={bg} variant={variant} {...restProps}>
      <Flex alignItems={'center'}>
        {icon && !iconRight && <Icon mr={2} {...iconProps} />}
        <Text className="text" textAlign="center" color={_titleColor} children={title} />
        {icon && iconRight && <Icon ml={2} {...iconProps} />}
      </Flex>
    </RBButton>
  );
};

export default RButton;
